export default __webpack_public_path__ + "f21ec9e.png";